import React from 'react';
import classnames from 'classnames';
import { apis, apiHolder as api } from 'api';
import styles from '../mailInfo.module.scss';
import { conferenceInit } from '@web-mail/util';
import { MailActions, useActions, useAppSelector } from '@web-common/state/createStore';
import IconCard from '@web-common/components/UI/IconCard';
import conferenceStyle from './conference.module.scss';
import SiriusMessage from '@web-common/components/UI/Message/SiriusMessage';
import { getIn18Text } from 'api';
import { remWaittingId } from '@web-mail-write/util';
import { TongyongRili } from '@sirius/icons';
const ConferenceBtn = () => {
    const mailActions = useActions(MailActions);
    const infoStatus = useAppSelector(state => state.mailReducer.currentMail.status);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const isDyncGroupSend = useAppSelector(state => state.mailReducer.currentMail.isDyncGroupSend);
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const conferenceShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.conferenceShow;
    const priaseMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.praiseMailShow;
    const taskMailShow = infoStatus === null || infoStatus === void 0 ? void 0 : infoStatus.taskMailShow;
    const trackApi = api.api.requireLogicalApi(apis.dataTrackerApiImp);
    let icsExist = false;
    if (Array.isArray(attachments)) {
        icsExist = attachments.some(i => i.mailId === currentMailId && !i.forwardWithout && i.fileType === 'ics');
    }
    const clickConf = async () => {
        trackApi.track('pcMail_click_conferenceInvitation_writeMailPage');
        trackApi.track('pcMail_click_addButton_writeMailPage', { buttonName: getIn18Text('RICHENG') });
        remWaittingId(currentMailId, true);
        if (icsExist) {
            SiriusMessage.info({
                content: React.createElement("span", null, getIn18Text('TIANJIARICHENGXU')),
            });
            return;
        }
        mailActions.doConferenceShow(true);
        mailActions.doConferenceSettting(true);
        const conference = await conferenceInit();
        if (conference) {
            mailActions.doConferenceChange(conference);
        }
        else {
            SiriusMessage.error({
                content: getIn18Text('MORENRILIBU'),
            });
        }
    };
    return conferenceShow || priaseMailShow || taskMailShow || isDyncGroupSend ? null : (React.createElement("div", { "data-test-id": "write-subject-conference", className: classnames(styles.btnWrapper, conferenceStyle.btnWrapper, {
            [conferenceStyle.isEdm]: process.env.BUILD_ISEDM,
        }), onClick: clickConf }, process.env.BUILD_ISEDM ? (React.createElement(React.Fragment, null,
        React.createElement(TongyongRili, { className: conferenceStyle.icon, wrapClassName: conferenceStyle.iconWrap }),
        React.createElement("span", { className: conferenceStyle.iconText }, getIn18Text('HUIYIYAOQING')))) : (React.createElement(React.Fragment, null,
        React.createElement("span", { className: styles.btnIcon },
            React.createElement(IconCard, { type: "conference" })),
        React.createElement("span", { className: styles.btnText }, getIn18Text('HUIYIYAOQING'))))));
};
export default ConferenceBtn;
